export default __webpack_public_path__ + "static/media/icon-bin.8c67a1fd.svg";